import React, { useEffect } from "react";
import { connect } from "react-redux";
import { RootState } from "../../../../redux/rootReducers";
import { LeaveAndWFHListPayloadType } from "../../../../commonTypes/stcoToolsType";
import {
  getLeaveAndWFHListAction,
  resetLeaveAndWFHList,
} from "../../../../redux/stcoTools";
import { LeaveAndUpcomingHistoryListType } from "../../../../redux/stcoTools/stcoToolsType";
import BoxLoader from "../../../commons/BoxLoader/BoxLoader";
import { LeaveApprovalIcon, ViewAllIcon } from "../../../../assets/images";

type AppProps = {
  dispatchLeaveAndWFHHistoryListAction: (
    data: LeaveAndWFHListPayloadType
  ) => void;
  leaveAndWFHHistoryList: [] | LeaveAndUpcomingHistoryListType[];
  token: string | null;
  fetching: boolean;
  history: any;
  id: number | null | undefined;
  dispatchResetLeaveAndWFHListAction: () => void;
  isLeaveApprovalPresent: boolean;
};

const LeavePendingApproval = ({
  dispatchLeaveAndWFHHistoryListAction,
  leaveAndWFHHistoryList,
  token,
  fetching,
  history,
  id,
  dispatchResetLeaveAndWFHListAction,
  isLeaveApprovalPresent,
}: AppProps) => {
  const leaveData =
    leaveAndWFHHistoryList?.length > 0
      ? leaveAndWFHHistoryList?.filter(
          (el: LeaveAndUpcomingHistoryListType) => el?.leave_type !== "WFH"
        )
      : [];
  const hanldePending = () => {
    history.push({
      pathname: `/my-space/pending-leaves`,
      state: { id },
    });
  };

  useEffect(() => {
    dispatchResetLeaveAndWFHListAction();
    if (token) {
      let finalData = {
        token,
        user_type: "manager",
        status: "1",
      };
      dispatchLeaveAndWFHHistoryListAction(finalData);
    }
  }, []);

  return (
    <div className="boxs w-100 pr-3 pb-3 pt-3 pl-2 mb-3" style={{ height: "118px" }}>
      {fetching ? (
        <BoxLoader style={{ height: "100%" }} />
      ) : (
        <>
          <div className="d-flex" style={{gap:"12px"}}>
            <img src={LeaveApprovalIcon} alt="Leave approval icon" />
            <div style={{display:"flex", flexDirection:"column",gap:"5px"}}>
            <span className="boxs-container-heading" 
            >
              Leave Pending Approvals
            </span>
            <span
                style={{ color: "#6e7491", fontSize: "13px", fontWeight: 500 }}
              >
                Total Leave Pending Approvals
              </span>
            </div>
          
          {isLeaveApprovalPresent ? (
            <>
              <div className="d-flex align-items-center">
                <div style={{ fontSize: "45px", fontWeight: 500 }}>
                  {leaveData?.length}
                </div>
                <div
                  className="ml-3"
                  style={{ color: "#dd4433", cursor: "pointer" }}
                  onClick={hanldePending}
                >
                  <img src={ViewAllIcon} alt="view all icon" />
                </div>
              </div>
              
            </>
          ) : (
            <div
              style={{
                color: "#6e7491",
                fontSize: "15px",
                fontWeight: 500,
                textAlign: "center",
                width:'142px'
              }}
            >
              You don't have access to this feature
            </div>
          )}
          </div>
        </>
      )}
    </div>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  dispatchLeaveAndWFHHistoryListAction: (data: LeaveAndWFHListPayloadType) =>
    dispatch(getLeaveAndWFHListAction(data)),
  dispatchResetLeaveAndWFHListAction: () => dispatch(resetLeaveAndWFHList()),
});

const mapStateToProps = (state: RootState) => ({
  leaveAndWFHHistoryList: state.stcoTools.leaveAndWFHHistoryList,
  token: state.auth.token,
  fetching: state.stcoTools.fetching,
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LeavePendingApproval);
